import { getHandleId } from '@common-services/utils';
import { Handle, Position } from 'reactflow';
import { nodeTypes } from '../bt-nodes-def';
import NodeContainer from '../node-container';
import classes from "./google-sheets-node.module.scss";
import CustomSourceHandle from '@common-components/bt-chatbot/custom-source-handle';
import { memo } from 'react';



type HandleSlot = { id?: string };
type GoogleSheetsNodeProps = {
    id: string;
    data: { handles?: { inputs?: HandleSlot[]; outputs?: HandleSlot[] } };
};

function GoogleSheetsNode({ id, data }: GoogleSheetsNodeProps) {

    const nodeColor = nodeTypes.googleSheets.color



    return (
        <>
            <Handle type="target" position={Position.Left} id={getHandleId(data.handles, 'target', 0) ?? undefined}
                style={{ backgroundColor: nodeColor, zIndex: 3, left: '-2px !important' }} />
            <NodeContainer type="googleSheets" id={id} />
            <CustomSourceHandle type="source" position={Position.Right} id={getHandleId(data.handles, 'source', 0) ?? undefined}
                className={classes.y_handle} connectioncount={1} />
            <CustomSourceHandle type="source" position={Position.Right} id={getHandleId(data.handles, 'source', 1) ?? undefined}
                className={classes.n_handle} connectioncount={1} />
        </>
    )
}

export default memo(GoogleSheetsNode);